import { Menubar } from "primereact/menubar";
import { Menu } from "primereact/menu";
import logo from "./logo.svg";
import styles from "./styles.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useContext, useRef } from "react";
import { userContext } from "../../context/user";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export const Navbar = () => {
  const navigate = useNavigate();
  const {
    detail,
    logout,
    isAdmin,
    isAccountManager,
    isPeopleEditor,
    isProfileManager,
    isProfileManagerTemp,
  } = useContext(userContext);

  const start = (
    <NavLink to="/" className={"mr-3"}>
      <img src={logo} alt="Harpier logo" />
    </NavLink>
  );

  const endMenuRef = useRef<Menu>(null);

  const endMenuItems = [
    {
      template: (item: any, options: any) => (
        <div
          className={classNames(options.className)}
          onClick={(e) => options.onClick(e)}
        >
          <div className="flex flex-column align max-w-full">
            <span className="font-bold white-space-nowrap overflow-hidden text-overflow-ellipsis">
              {detail?.email}
            </span>
            <small className="text-sm">{detail?.roles.join(", ")}</small>
          </div>
        </div>
      ),
      // command: () => navigate("/users/profile"),
    },
    { separator: true },
    {
      label: "Logout",
      command: () => logout(),
      icon: "fa-solid fa-right-from-bracket",
    },
  ];

  const end = (
    <>
      <Menu
        model={endMenuItems}
        popup={true}
        ref={endMenuRef}
        style={{ minWidth: 250 }}
      />

      <Button
        icon={"fa-solid fa-circle-user"}
        rounded={true}
        severity="secondary"
        onClick={(e) => endMenuRef.current?.toggle(e)}
      />
    </>
  );

  const items = [
    {
      label: "User",
      command: () => navigate("/users"),
      visible: isAdmin(),
    },
    {
      label: "Journey Tracker Template",
      command: () => navigate("/journey-tracker-templates"),
      visible: isAdmin(),
    },
    {
      label: "Checklist",
      command: () => navigate("/checklists"),
      visible: isAdmin(),
    },
    {
      label: "Institution",
      command: () => navigate("/institutions"),
      visible: isAdmin() || isProfileManagerTemp(),
    },
    {
      label: "Representative",
      command: () => navigate("/representatives"),
      visible: isAdmin(),
    },
    {
      label: "CRM",
      visible: isAdmin(),
      items: [
        {
          label: "Field Types",
          command: () => navigate("/crm/field-types"),
          visible: isAdmin(),
        },
      ],
    },
    {
      label: "Tally",
      visible: isAdmin(),
      items: [
        {
          label: "Forms",
          command: () => navigate("/tally/forms"),
          visible: isAdmin(),
        },
        {
          label: "Add Form",
          command: () => navigate("/tally/forms/add"),
          visible: isAdmin(),
        },
      ],
    },
    {
      label: "Administration",
      visible: isAdmin(),
      items: [
        {
          label: "Contexts",
          command: () => navigate("/admin/contexts"),
          visible: isAdmin(),
        },
        {
          label: "Fields",
          command: () => navigate("/admin/fields"),
          visible: isAdmin(),
        },
        {
          label: "Campus Activities",
          command: () => navigate("/admin/campus-activities"),
          visible: isAdmin(),
        },
        {
          label: "Tags",
          command: () => navigate("/admin/tags"),
          visible: isAdmin(),
        },
        {
          label: "People Connection",
          command: () => navigate("/people-connection"),
          visible: isAdmin(),
        },
        {
          label: "Story Interactions",
          command: () => navigate("/story-interactions"),
          visible: isAdmin(),
        },
        {
          label: "Voice Requests",
          command: () => navigate("/voice-requests"),
          visible: isAdmin(),
        },
      ],
    },
    {
      label: "Journey Tracker",
      command: () => navigate("/journey-trackers"),
      visible: false,
    },
    {
      label: "Interaction",
      command: () => navigate("/interactions"),
      visible: false,
    },
    {
      label: "Ranking",
      command: () => navigate("/institution-rankings"),
      visible: false,
    },
    {
      label: "People",
      command: () => navigate("/people"),
      visible:
        isAdmin() ||
        isAccountManager() ||
        isPeopleEditor() ||
        isProfileManager() ||
        isProfileManagerTemp(),
    },
    {
      label: "Account",
      visible: isAdmin(),
      items: [
        {
          label: "Accounts",
          command: () => navigate("/accounts"),
        },
        {
          label: "Dashboard",
          command: () => navigate("/dashboard"),
        },
      ],
    },
  ];

  return (
    <Menubar
      start={start}
      end={end}
      model={items}
      className={classNames({
        [styles.navbar]: true,
        "menubar-user": !isAdmin(),
      })}
    />
  );
};
